
const books = [ 
  // aysar tafaseer books 0 
    {
      "id": 0,
      "name": "الجزء الأول",
      "imglink": "/assets/bookimage/quran/qr1.jpg",
      "booklink": "https://firebasestorage.googleapis.com/v0/b/anood-tafseer.appspot.com/o/aysar%2Faysar1.pdf?alt=media&token=e0fd1f23-b023-4d35-aaeb-df90b790613c"
    },
    {
      "id": 1,
      "name": "الجزء الثاني",
      "imglink": "/assets/bookimage/quran/qr2.jpg",
      "booklink": "https://firebasestorage.googleapis.com/v0/b/anood-tafseer.appspot.com/o/aysar%2Faysar2.pdf?alt=media&token=35335a19-4e11-4958-a99c-93f08a21ec82"
    },
    {
      "id": 2,
      "name": "الجزء الثالث",
      "imglink": "/assets/bookimage/quran/qr3.jpg",
      "booklink": "https://firebasestorage.googleapis.com/v0/b/anood-tafseer.appspot.com/o/aysar%2Faysar3.pdf?alt=media&token=f0f23dbe-eec6-4612-accf-fd90986ad4af"
    },
    {
      "id": 3,
      "name": "الجزء الرابع",
      "imglink": "/assets/bookimage/quran/qr3.jpg",
      "booklink": "https://firebasestorage.googleapis.com/v0/b/anood-tafseer.appspot.com/o/aysar%2Faysar4.pdf?alt=media&token=0fad8987-c60a-4862-a14f-c438033ffb05"
    },
    {
      "id": 4,
      "name": "الجزء الخامس",
      "imglink": "/assets/bookimage/quran/qr3.jpg",
      "booklink": "https://firebasestorage.googleapis.com/v0/b/anood-tafseer.appspot.com/o/aysar%2Faysar5.pdf?alt=media&token=6fefa3a7-499c-42d0-8ec8-8b9169477f5a"
    },

  // ebn katheer books 1

  {
      "id": 5,
      "name": "الجزء الأول",
      "imglink": "/assets/bookimage/tajweed/tj1.jpg",
      "booklink": "https://firebasestorage.googleapis.com/v0/b/anood-tafseer.appspot.com/o/tafseer-ibn-katheer%2Fمختصر%20تفسير%20بن%20كثير%201.pdf?alt=media&token=f7d32d82-b4b1-4ead-8236-f971b80897bb"
    },
    {
      "id": 6,
      "name": "الجزء الثاني",
      "imglink": "/assets/bookimage/tajweed/tj2.jpg",
      "booklink": "https://firebasestorage.googleapis.com/v0/b/anood-tafseer.appspot.com/o/tafseer-ibn-katheer%2Fمختصر%20تفسير%20بن%20كثير%202.pdf?alt=media&token=7c42c2dd-6546-4e2a-b725-e60820f76d8e"
    },
    {
      "id": 7,
      "name": "الجزء الثالث",
      "imglink": "/assets/bookimage/tajweed/tj3.jpg",
      "booklink": "https://firebasestorage.googleapis.com/v0/b/anood-tafseer.appspot.com/o/tafseer-ibn-katheer%2Fمختصر%20تفسير%20بن%20كثير%203.pdf?alt=media&token=1701793e-57fc-495e-a9b5-73a377dd2dfa"
    },

  // tabary book 2

  {
      "id": 8,
      "name": "الجزء ١",
      "imglink": "/assets/bookimage/feqh/f1.jpg",
      "booklink": ""
    },
    {
      "id": 9,
      "name": "الجزء ٢",
      "imglink": "/assets/bookimage/feqh/f2.jpg",
      "booklink": ""
    },
    {
      "id": 10,
      "name": "الجزء ٣",
      "imglink": "/assets/bookimage/feqh/f3.jpg",
      "booklink": ""
    },
    {
      "id": 11,
      "name": "الجزء ٤",
      "imglink": "/assets/bookimage/feqh/f4.jpg",
      "booklink": ""
    },
    {
      "id": 12,
      "name": "الجزء ٥",
      "imglink": "/assets/bookimage/feqh/f5.jpg",
      "booklink": ""
    },
    {
      "id": 13,
      "name": "الجزء ٦",
      "imglink": "/assets/bookimage/feqh/f6.jpg",
      "booklink": ""
    },
    {
      "id": 14,
      "name": "الجزء ٧",
      "imglink": "/assets/bookimage/feqh/f7.jpg",
      "booklink": ""
    },
    {
      "id": 15,
      "name": "الجزء ٨",
      "imglink": "/assets/bookimage/feqh/f8.jpg",
      "booklink": ""
    },
    {
      "id": 16,
      "name": "الجزء ٩",
      "imglink": "/assets/bookimage/feqh/fq1.jpg",
      "booklink": ""
    },
    {
      "id": 17,
      "name": "الجزء ١٠",
      "imglink": "/assets/bookimage/feqh/fq2.jpg",
      "booklink": ""
    },
    {
      "id": 18,
      "name": "الجزء ١١",
      "imglink": "/assets/bookimage/feqh/fq3.jpg",
      "booklink": ""
    },
    {
      "id": 19,
      "name": "الجزء ١٢",
      "imglink": "/assets/bookimage/feqh/fq4.jpg",
      "booklink": ""
    },
    {
      "id": 20,
      "name": "الجزء ١٣",
      "imglink": "/assets/bookimage/feqh/fq5.jpg",
      "booklink": ""
    },
    {
      "id": 21,
      "name": "الجزء ١٤",
      "imglink": "/assets/bookimage/feqh/fq6.jpg",
      "booklink": ""
    },
    {
      "id": 22,
      "name": "الجزء ١٥",
      "imglink": "/assets/bookimage/feqh/fq6.jpg",
      "booklink": ""
    },
    {
      "id": 23,
      "name": "الجزء ١٦",
      "imglink": "/assets/bookimage/feqh/fq6.jpg",
      "booklink": ""
    },
    {
      "id": 24,
      "name": "الجزء ١٧",
      "imglink": "/assets/bookimage/feqh/fq6.jpg",
      "booklink": ""
    },
    {
      "id": 25,
      "name": "الجزء ١٨",
      "imglink": "/assets/bookimage/feqh/fq6.jpg",
      "booklink": ""
    },
    {
      "id": 26,
      "name": "الجزء ١٩",
      "imglink": "/assets/bookimage/feqh/fq6.jpg",
      "booklink": ""
    },
    {
      "id": 27,
      "name": "الجزء ٢٠",
      "imglink": "/assets/bookimage/feqh/fq6.jpg",
      "booklink": ""
    },
    {
      "id": 28,
      "name": "الجزء ٢١",
      "imglink": "/assets/bookimage/feqh/fq6.jpg",
      "booklink": ""
    },
    {
      "id": 29,
      "name": "الجزء ٢٢",
      "imglink": "/assets/bookimage/feqh/fq6.jpg",
      "booklink": ""
    },
    {
      "id": 30,
      "name": "الجزء ٢٣",
      "imglink": "/assets/bookimage/feqh/fq6.jpg",
      "booklink": ""
    },
    {
      "id": 31,
      "name": "الجزء ٢٤",
      "imglink": "/assets/bookimage/feqh/fq6.jpg",
      "booklink": ""
    },
    {
      "id": 32,
      "name": "الجزء ٢٥و٢٦",
      "imglink": "/assets/bookimage/feqh/fq6.jpg",
      "booklink": ""
    },

    // bedaya we nehaya book 3

    {
        "id": 33,
        "name": "الجزء 1",
        "imglink": "/assets/bookimage/feqh/f1.jpg",
        "booklink": ""
      },
      {
        "id": 34,
        "name": "الجزء 2",
        "imglink": "/assets/bookimage/feqh/f2.jpg",
        "booklink": ""
      },
      {
        "id": 35,
        "name": "الجزء 3",
        "imglink": "/assets/bookimage/feqh/f3.jpg",
        "booklink": ""
      },
      {
        "id": 36,
        "name": "الجزء 4",
        "imglink": "/assets/bookimage/feqh/f4.jpg",
        "booklink": ""
      },
      {
        "id": 37,
        "name": "الجزء 5",
        "imglink": "/assets/bookimage/feqh/f5.jpg",
        "booklink": ""
      },
      {
        "id": 38,
        "name": "الجزء 6",
        "imglink": "/assets/bookimage/feqh/f6.jpg",
        "booklink": ""
      },
      {
        "id": 39,
        "name": "الجزء 7",
        "imglink": "/assets/bookimage/feqh/f7.jpg",
        "booklink": ""
      },
      {
        "id": 40,
        "name": "الجزء 8",
        "imglink": "/assets/bookimage/feqh/f8.jpg",
        "booklink": ""
      },
      {
        "id": 41,
        "name": "الجزء 9",
        "imglink": "/assets/bookimage/feqh/fq1.jpg",
        "booklink": ""
      },
      {
        "id": 42,
        "name": "الجزء 10",
        "imglink": "/assets/bookimage/feqh/fq2.jpg",
        "booklink": ""
      },
      {
        "id": 43,
        "name": "الجزء 11",
        "imglink": "/assets/bookimage/feqh/fq3.jpg",
        "booklink": ""
      },
      {
        "id": 44,
        "name": "الجزء 12",
        "imglink": "/assets/bookimage/feqh/fq4.jpg",
        "booklink": ""
      },
      {
        "id": 45,
        "name": "الجزء 13",
        "imglink": "/assets/bookimage/feqh/fq5.jpg",
        "booklink": ""
      },
      {
        "id": 46,
        "name": "الجزء 14",
        "imglink": "/assets/bookimage/feqh/fq6.jpg",
        "booklink": ""
      },

      // hadeeth book 3
  
      {
          "id": 47,
          "name": "البخاري",
          "imglink": "/assets/bookimage/feqh/f1.jpg",
          "booklink": ""
        },
        {
          "id": 48,
          "name": "مسلم",
          "imglink": "/assets/bookimage/feqh/f2.jpg",
          "booklink": ""
        },
        {
          "id": 49,
          "name": "",
          "imglink": "/assets/bookimage/feqh/f3.jpg",
          "booklink": ""
        },
        {
          "id": 50,
          "name": "",
          "imglink": "/assets/bookimage/feqh/f4.jpg",
          "booklink": ""
        },
        {
          "id": 51,
          "name": "",
          "imglink": "/assets/bookimage/feqh/f5.jpg",
          "booklink": ""
        },
        {
          "id": 52,
          "name": "",
          "imglink": "/assets/bookimage/feqh/f6.jpg",
          "booklink": ""
        },
        {
          "id": 53,
          "name": "",
          "imglink": "/assets/bookimage/feqh/f7.jpg",
          "booklink": ""
        },
        {
          "id": 54,
          "name": "",
          "imglink": "/assets/bookimage/feqh/f8.jpg",
          "booklink": ""
        },
        {
          "id": 55,
          "name": "",
          "imglink": "/assets/bookimage/feqh/fq1.jpg",
          "booklink": ""
        },
        {
          "id": 56,
          "name": "",
          "imglink": "/assets/bookimage/feqh/fq2.jpg",
          "booklink": ""
        },
        {
          "id": 57,
          "name": "",
          "imglink": "/assets/bookimage/feqh/fq3.jpg",
          "booklink": ""
        },
        {
          "id": 58,
          "name": "",
          "imglink": "/assets/bookimage/feqh/fq4.jpg",
          "booklink": ""
        },
        {
          "id": 59,
          "name": "",
          "imglink": "/assets/bookimage/feqh/fq5.jpg",
          "booklink": ""
        },
        {
          "id": 60,
          "name": "",
          "imglink": "/assets/bookimage/feqh/fq6.jpg",
          "booklink": ""
        },
        // quran
        {
          "id": 61,
          "name": "القرآن",
          "imglink": "/assets/bookimage/feqh/f1.jpg",
          "booklink": "https://firebasestorage.googleapis.com/v0/b/anood-tafseer.appspot.com/o/quran%2Fquran.pdf?alt=media&token=bcc4d126-f95b-41f5-bdce-78b2f68f7799"
        },
      
]

export default books;